import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppUser, canEditUser } from '@context/shared/types/user';
import { AuthService } from '../services';

@Pipe({
	name: 'canEditUser',
	standalone: true,
})
export class CanEditUserPipe implements PipeTransform {
	private readonly authService = inject(AuthService);

	transform(user: AppUser) {
		if (!this.authService.user?.role) return false;
		return canEditUser(this.authService.user, user);
	}
}
